import { render } from "./profile-settings.vue?vue&type=template&id=bb709a46&scoped=true"
import script from "./profile-settings.vue?vue&type=script&lang=js"
export * from "./profile-settings.vue?vue&type=script&lang=js"

import "./profile-settings.vue?vue&type=style&index=0&id=bb709a46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb709a46"]])

export default __exports__